import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchGatepassDetail = createAsyncThunk(
	"fetchGatepassDetail",
	async (id, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.get(`gatepass/getbyid/${id}`);
			return response.data;
		} catch (err) {
			if (!err.response) throw err;
			return rejectWithValue(err.response.data);
		}
	}
);

const GatepassDetailSlice = createSlice({
	name: "GatepassDetailSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	reducers: {
		resetGatepassDetail: (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchGatepassDetail.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(fetchGatepassDetail.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload?.data || null;
		});
		builder.addCase(fetchGatepassDetail.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetGatepassDetail } = GatepassDetailSlice.actions;
export default GatepassDetailSlice.reducer;
